// type Role = "ai-market-place";

interface FilePathParams {
  // role: Role;
  identifier: string; // could be email, userId, or any unique field
  context?: string; // optional - like 'profile', 'project', etc.
  fileName: string;
}
export const generateFilePathForS3 = ({
  // role,
  identifier,
  context,
  fileName,
}: FilePathParams) => {
  const segments = ["ai-market-place", identifier];

  if (context) {
    segments.push(context);
  }
  const safeFileName = fileName.replace(/\s/g, "");

  segments.push(safeFileName);

  return segments.map(encodeURIComponent).join("/");
};
